/**
 * Check if the current environment supports cookies.
 *
 * @see https://git.io/JcXiP
 * @returns
 */
function supportsCookies() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "test";

  try {
    document.cookie = "".concat(cookieName, "=1");
    var result = document.cookie.indexOf("".concat(cookieName, "=")) !== -1;
    document.cookie = "".concat(cookieName, "=1; expires=Thu, 01-Jan-1970 00:00:01 GMT");
    return result;
  } catch (e) {
    return false;
  }
}

export { supportsCookies };